import React, { ComponentProps } from "react";

import styles from "./Input.module.scss";

type InputType = {
  hasError: boolean;
  isValid: boolean;
  loading?: boolean;
  wrapperClass?: string;
};

const Input: React.FC<InputType & ComponentProps<"input">> = ({
  className,
  hasError,
  isValid,
  loading,
  ...rest
}) => {
  const shouldShowValidIcon = isValid && !hasError && !loading;

  return (
    <div className={styles.textField}>
      <input
        className={`${styles.field} ${hasError && styles.error}`}
        {...rest}
      />
      <img
        src={`/icons/drip-form-valid-icon.svg`}
        alt="icon"
        className={`${styles.icon} ${
          shouldShowValidIcon ? styles.iconShow : styles.iconHidden
        }`}
      />
      {hasError && (
        <img
          src={`/icons/drip-form-invalid-icon.svg`}
          alt="icon"
          className={styles.icon}
        />
      )}
      {loading && <div className={styles.loading} />}
    </div>
  );
};

export default Input;
